import { render, staticRenderFns } from "./express.vue?vue&type=template&id=fc2ef020&scoped=true&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"
import style0 from "./express.vue?vue&type=style&index=0&id=fc2ef020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ef020",
  null
  
)

/* custom blocks */
import block0 from "./express.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports